<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="新增角色"
      center
      width="600px"
      :before-close="$onClose"
      destroy-on-close
      @close="close()"
    >
      <div>
        <div>
          <h4 class="title">角色类型</h4>
          <el-input v-model="template_cn" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">权限</h4>
          <!-- <el-select v-model="api" placeholder="请选择" multiple>
            <el-option
              v-for="item in apiListArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <el-button type="primary" v-preventReClick @click="showPower()"
            >选择权限</el-button
          >
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
      <role-power-dialog
        ref="_rolePowerDialog"
        :api-list-array="apiListArray"
      ></role-power-dialog>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";
import * as StrUtils from "@/utils/strUtils.js";
import rolePowerDialog from "@/components/dialog/rolePowerDialog";

export default {
  components: {
    rolePowerDialog,
  },
  data() {
    return {
      changVisible: false,

      apiIds: "",
      template_cn: "",
    };
  },
  props: ["apiListArray"],
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.$emit("closePower");
      this.changVisible = false;
      this.apiIds = "";
      this.template_cn = "";
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (StrUtils.isEmpty(this.template_cn)) {
        this.$message.error("请完善信息");
        return;
      }
      if (StrUtils.isEmpty(this.apiIds)) {
        this.$message.error("请选择至少一项权限");
        return;
      }
      this.createPowerTemplate();
    },
    showPower() {
      this.$emit("showPower", true, this.apiIds);
    },
    //页面初始化时加载的事件
    show() {
      this.changVisible = true;
    },
    // 选择完权限列表
    setPowerIds(ids) {
      this.apiIds = ids;
    },
    // 新增管理员
    createPowerTemplate: function () {
      this.$api
        .createPowerTemplate({
          token: localStorage.getItem("token"),
          api_list: this.apiIds,
          template_cn: this.template_cn,
        })
        .then(({ data }) => {
          this.$emit("toSave");
          this.close();
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/roleAddDialog.vue